import { render } from "./SearchInstructorsCourses.vue?vue&type=template&id=aaf796b6&scoped=true&ts=true"
import script from "./SearchInstructorsCourses.vue?vue&type=script&lang=ts"
export * from "./SearchInstructorsCourses.vue?vue&type=script&lang=ts"

import "./SearchInstructorsCourses.vue?vue&type=style&index=0&id=aaf796b6&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaf796b6"]])

export default __exports__